function undoStoreEnhancer(bufferSize=100) {
    return (next) => (reducer, preloadedState) => {
        let initialState = preloadedState;
        let actions = [];
        const store = next((state, action) => {
            if (action.type === 'undo') {
                const undone = action.payload.action;
                actions = actions.filter(a => a !== undone);
                state = initialState;
                for (const a of actions) {
                    state = reducer(state, a);
                }
            } else {
                state = reducer(state, action);
                actions.push(action);
                action.undo = () => store.dispatch({type: 'undo', payload: { action }});
                if (actions.length > bufferSize) {
                    const oldAction = actions.shift();
                    delete oldAction.undo;
                    initialState = reducer(initialState, oldAction);
                }
            }
            return state;
        }, preloadedState);
        return store;
    };
}

export default undoStoreEnhancer;
